module.exports = __webpack_public_path__ + "static/media/intro-bg.704c3270.png";


//////////////////
// WEBPACK FOOTER
// /src/globals/images/intro-bg.png
// module id = 205
// module chunks = 0